export function isFalsy(value) {
  return ['false', '0', ''].indexOf(
    String(value || '').trim().toLowerCase()
  ) > -1;
}

export function isTruthy(value) {
  return !isFalsy(value);
}
